import React from 'react'
import styles from './pagination.module.scss'
import { Button } from '../Button/Button'

export type PaginationProps = {
  /** Zero-based index of the first row on the current page. */
  offset: number
  /** Page size. */
  limit: number
  /** Total row count across all pages. */
  total: number
  onPrev: () => void
  onNext: () => void
}

/**
 * Offset-based pagination footer: "← Anterior" · range label · "Siguiente →".
 * Purely presentational — the caller owns the offset state and re-queries on
 * onPrev/onNext (see OrderHistoryPage for the pattern this was extracted from).
 */
export const Pagination: React.FC<PaginationProps> = ({ offset, limit, total, onPrev, onNext }) => {
  const hasPrev = offset > 0
  const hasNext = offset + limit < total
  const rangeLabel = total === 0 ? '' : `${offset + 1}–${Math.min(offset + limit, total)} de ${total}`

  return (
    <div className="row-flx flx-a-c flx-j-c flx-gap-16">
      <Button variant="textual" label="← Anterior" onClick={onPrev} disabled={!hasPrev} />
      <span className={`txt-light-kale ${styles['pagination__range']}`}>{rangeLabel}</span>
      <Button variant="textual" label="Siguiente →" onClick={onNext} disabled={!hasNext} />
    </div>
  )
}
